import React from 'react'

function NotFound() {
    return ( 
         <div className='container p-5 mb-5 mt-5'>
            <div className='row text-center'>
               <h1 className='mt-5 mb-4 fs-2'>404 NOT FOUND</h1>
               <p className='mb-5 fs-5 text-muted'>Sorry, the page you are looking for does not exist.</p>
            </div>

        </div>
     );
}

export default NotFound;